<template>
  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>
      
      <!-- 上传文件区域 -->
      <el-form-item label="上传文件">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.files">
            <transition-group>
              <div v-for="(item, index) in form.files" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="file_path" v-if="isImageFile(item.file_path)"/>
                  <div v-else class="file-icon">
                    <i class="el-icon-document" style="font-size: 40px; color: #409EFF;"></i>
                    <p class="file-name">{{ getFileName(item.file_path) }}</p>
                  </div>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteFile(index)">
                    <i class="el-icon-close"></i>
                  </a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openFileUpload">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>

    <!--文件上传组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnFileFunc">上传文件</Upload>
  </div>
</template>

<script>
import Sign_upApi from '@/api/sign_up.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';

export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      form: {
        status: false,
        files: [] // 存储上传的文件
      },
      setting: [],
      loading: false,
      isProductUpload: false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      Sign_upApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values != '[]'){
            self.form = data.data.vars.values;
            // 确保files数组存在
            if (!self.form.files) {
              self.$set(self.form, 'files', []);
            }
          }
        })
        .catch(error => {});
    },
    
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      Sign_upApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    
    /*打开文件上传*/
    openFileUpload() {
      this.isProductUpload = true;
    },
    
    /*获取上传的文件*/
    returnFileFunc(e) {
      let self = this;
      if (e != null) {
        // 将新上传的文件添加到文件列表中
        let newFiles = self.form.files.concat(e);
        self.$set(self.form, "files", newFiles);
      }
      self.isProductUpload = false;
    },
    
    /*删除文件*/
    deleteFile(index) {
      this.form.files.splice(index, 1);
    },
    
    /*判断是否为图片文件*/
    isImageFile(filePath) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      const extension = filePath.substring(filePath.lastIndexOf('.')).toLowerCase();
      return imageExtensions.includes(extension);
    },
    
    /*获取文件名*/
    getFileName(filePath) {
      return filePath.substring(filePath.lastIndexOf('/') + 1);
    }
  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
  display: flex;
  justify-content: center;
  align-items: center;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
  cursor: pointer;
}

.draggable-list .img-select i {
  color: #409eff;
}

.file-icon {
  text-align: center;
  padding: 10px;
}

.file-name {
  font-size: 12px;
  margin-top: 5px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/sign_up/setting/getSetting.vue